import { shallowEqual, useSelector } from 'react-redux';
import { CustomerDataAddressInterface } from 'swagger/ts/Definitions';
import { useMemo } from 'react';

import { AppendState } from '../user.reducer';

/**
 * This API is for READING addresses.
 */
export interface UseAddressesApi {
    addresses: CustomerDataAddressInterface[];
    shippingAddress: CustomerDataAddressInterface | undefined;
    billingAddress: CustomerDataAddressInterface | undefined;
    otherAddresses: CustomerDataAddressInterface[];
}

const EMPTY_ARR = [];
const addressesSelector = (s: AppendState) => s.user.data?.addresses || EMPTY_ARR;

/**
 * This hook should be used to read the current
 * users addresses.
 */
export function useAddresses(): UseAddressesApi {
    const addresses = useSelector(addressesSelector, shallowEqual);
    /**
     * Default Shipping address
     */
    const shippingAddress = useMemo(() => {
        return addresses.find((x) => x.default_shipping);
    }, [addresses]);
    /**
     * Default Billing address
     */
    const billingAddress = useMemo(() => {
        return addresses.find((x) => x.default_billing);
    }, [addresses]);
    /**
     * Addresses which are neither shipping or billing
     */
    const otherAddresses = useMemo(() => {
        return addresses.filter((address) => {
            return !address.default_shipping && !address.default_billing;
        });
    }, [addresses]);

    return {
        addresses,
        shippingAddress,
        billingAddress,
        otherAddresses,
    };
}
